import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIList from 'UIComponents/list/UIList';
import { AllProductLines } from 'self-service-api/constants/ProductLines';
import ProductIcon from '../common/ProductIcon';
import { Section } from './MerchCardSharedComponents';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StarterCustomerPlatformUpsellCardBusinessObjectives = ({
  currentProductLine,
  commonStyles
}) => {
  // display all product lines except the current product line (the hub page you are on)
  const DisplayedProductLines = AllProductLines.filter(productLine => productLine !== currentProductLine);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Section, {
      className: "p-top-8",
      style: Object.assign({
        gridRowStart: 8
      }, commonStyles),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `merchCards.starterCustomerPlatformUpsellCard.businessObjectives.header.${currentProductLine}`
      })
    }), /*#__PURE__*/_jsx(Section, {
      className: "p-bottom-6",
      style: Object.assign({
        gridRowStart: 9,
        lineHeight: 'normal',
        fontSize: '14px'
      }, commonStyles),
      children: /*#__PURE__*/_jsx(UIList, {
        children: DisplayedProductLines.map(localProductLine => {
          return /*#__PURE__*/_jsxs(UIFlex, {
            className: "m-y-3",
            align: "start",
            children: [/*#__PURE__*/_jsx(ProductIcon, {
              className: "display-inline m-right-3",
              productLine: localProductLine,
              height: 24,
              responsive: false
            }), /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx("div", {
                style: {
                  fontWeight: 500
                },
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: `merchCards.starterCustomerPlatformUpsellCard.businessObjectives.${localProductLine}.title`
                })
              }), /*#__PURE__*/_jsx("div", {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: `merchCards.starterCustomerPlatformUpsellCard.businessObjectives.${localProductLine}.subtext`
                })
              })]
            })]
          }, localProductLine);
        })
      })
    })]
  });
};
export default StarterCustomerPlatformUpsellCardBusinessObjectives;